module.exports = __WEBPACK_EXTERNAL_MODULE_alpheios_data_models__;